import {Organization, OrganizationParams} from '$constants/api-infos'
import {GetInsuranceMyAssetResponse} from '$share/types/insurance/myasset'
import {authInstance} from '$utils/api'
import {createTanstackQuery} from '$utils/createQuery'

export const getOrganizationQuery = createTanstackQuery<Organization, OrganizationParams>((params) => ({
    url: `/mydata/organization`,
    method: 'GET',
    params,
}))

export const getInsuranceMyAssetQuery = createTanstackQuery<GetInsuranceMyAssetResponse>(() => ({
    url: '/insurance/myasset',
    method: 'GET',
    fetcher: authInstance,
}))
